import { gql } from '@apollo/client';
import { AreaTypeInput } from '../mutations/areaMutations';

/**
 * 路线邮编编辑「确认生效」前的跨仓影响预览：返回本次编辑从其他仓迁入邮编所涉及的原仓明细，
 * 供二次确认弹框按仓粒度展示。无跨仓时 items 为空。只读，无副作用。
 */
export const PREVIEW_ROUTE_ZIPCODE_CHANGE_CROSS_WAREHOUSE = gql`
    query PreviewRouteZipcodeChangeCrossWarehouse($warehouseId: Long!, $areas: [AreaTypeInput!]!, $deletedAreaIds: [Long!]) {
        previewRouteZipcodeChangeCrossWarehouse(warehouseId: $warehouseId, areas: $areas, deletedAreaIds: $deletedAreaIds) {
            items {
                warehouseId
                warehouseName
                routeCount
                zipcodeCount
            }
        }
    }
`;

export interface CrossWarehouseImpactItem {
    warehouseId: number;
    warehouseName: string | null;
    routeCount: number;
    zipcodeCount: number;
}

export interface CrossWarehouseImpact {
    items: CrossWarehouseImpactItem[];
}

export interface PreviewRouteZipcodeChangeCrossWarehouseResponse {
    previewRouteZipcodeChangeCrossWarehouse: CrossWarehouseImpact;
}

export interface PreviewRouteZipcodeChangeCrossWarehouseVariables {
    warehouseId: number;
    areas: AreaTypeInput[];
    deletedAreaIds?: number[];
}
